"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSnapMediaTypeForWebPlayer = exports.toSnapMediaType = void 0;
const web_story_web_player_1 = require("@snapchat/web-story-web-player");
const stories_1 = require("../types/stories");
function toSnapMediaType(snapMediaTypeString) {
    if (snapMediaTypeString === "IMAGE")
        return stories_1.MediaType.IMAGE;
    if (snapMediaTypeString === "VIDEO")
        return stories_1.MediaType.VIDEO;
    if (snapMediaTypeString === "VIDEO_NO_SOUND")
        return stories_1.MediaType.VIDEO_NO_SOUND;
    return stories_1.MediaType.IMAGE;
}
exports.toSnapMediaType = toSnapMediaType;
function toSnapMediaTypeForWebPlayer(snapMediaTypeString) {
    if (snapMediaTypeString === "IMAGE")
        return web_story_web_player_1.SnapMediaType.Image;
    if (snapMediaTypeString === "VIDEO")
        return web_story_web_player_1.SnapMediaType.Video;
    if (snapMediaTypeString === "VIDEO_NO_SOUND")
        return web_story_web_player_1.SnapMediaType.VideoNoSound;
    return web_story_web_player_1.SnapMediaType.Image;
}
exports.toSnapMediaTypeForWebPlayer = toSnapMediaTypeForWebPlayer;
//# sourceMappingURL=typeConversions.js.map